import { writable } from 'svelte/store'
import { get } from 'svelte/store'

export const userStore = writable(null)
export const batchesStore = writable(null)
export const modalShowStore = writable('')
export const socketStore = writable(null)
export const alertStore = writable([])
export const sidebarOpenStore = writable(false)
export const reportPageInfo = writable({})
export const downloadCurrentBatchStore = writable(null)
export const bannerStore = writable(false)
export const buyCreditsPreselectStore = writable(null)
export const pricingModalTabStore = writable('payg')
/** @type {import('svelte/store').Writable<import('../lib/onboarding').UseCase | null>} */
export const pendingOnboardingTourStore = writable(null)
/** @type {import('svelte/store').Writable<import('../lib/onboarding').UseCase | null>} */
export const pendingOnboardingBannerStore = writable(null)

// Create a persistent testimonial banner store
function createTestimonialBannerStore() {
  // Check if we're in the browser
  const isBrowser = typeof window !== 'undefined'

  // Get the dismissed state from localStorage
  const wasDismissed = isBrowser
    ? localStorage.getItem('testimonialBannerDismissed') === 'true'
    : false

  // Even if it was dismissed, give it a 10% chance to show again on page load
  // Adjust the 0.1 value to change probability (0.1 = 10%, 0.05 = 5%, 0.2 = 20%, etc.)
  const randomChanceToShow = wasDismissed ? Math.random() < 0.1 : true

  // Determine initial value: show if never dismissed OR if random chance triggered
  const initialValue = !wasDismissed || randomChanceToShow

  const store = writable(initialValue)

  return {
    subscribe: store.subscribe,
    hideBanner: () => {
      store.set(false)
      if (isBrowser) {
        localStorage.setItem('testimonialBannerDismissed', 'true')
      }
    },
    showBanner: () => {
      store.set(true)
      if (isBrowser) {
        localStorage.removeItem('testimonialBannerDismissed')
      }
    }
  }
}

export const testimonialBannerStore = createTestimonialBannerStore()

modalShowStore.openModal = (key) => {
  modalShowStore.set(key)
}

modalShowStore.closeModal = () => {
  modalShowStore.set('')
}

bannerStore.showBanner = () => {
  bannerStore.set(true)
}

bannerStore.hideBanner = () => {
  bannerStore.set(false)
}

/*
 * addAlert
 * @param {Object} alert
 * @param {String} alert.title
 * @param {String} alert.text
 *
 * @returns {void}
 */
alertStore.addAlert = (alert) => {
  alert.uuid ||= Math.random().toString(36).substring(7)

  // if the alert exists already in the alertStore, then return early
  if (get(alertStore).find((a) => a.uuid === alert.uuid)) return

  alertStore.update((alerts) => [...alerts, alert])

  if (alert.type === 'batch_progress') return
  setTimeout(() => {
    alertStore.update((alerts) => alerts.filter((a) => a.uuid !== alert.uuid))
  }, 5000)
}
